import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="py-24 md:py-32 bg-cream overflow-hidden" data-id="element-11">
      <div className="max-w-7xl mx-auto px-6" data-id="element-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-13">
          {/* Image Side */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-14">
            <div className="relative aspect-[3/4] w-full max-w-md mx-auto lg:mr-auto overflow-hidden rounded-sm" data-id="element-15">
              <img src="https://cdn.magicpatterns.com/uploads/wD7Uw38YYjCv7LqMFwPhQJ/photos_by_tunga.jpg" alt="Photographer Silhouette at Sunset" className="w-full h-full object-cover" data-id="element-16" />
              <div className="absolute inset-0 border-[1px] border-white/20 m-4 pointer-events-none" data-id="element-17" />
            </div>
            {/* Decorative Element */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-sage/20 -z-10 rounded-full blur-2xl" data-id="element-18" />
            <div className="absolute -top-6 -left-6 w-40 h-40 bg-gold/10 -z-10 rounded-full blur-2xl" data-id="element-19" />
          </motion.div>

          {/* Text Side */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="lg:pl-12" data-id="element-20">
            <span className="text-gold text-sm tracking-widest uppercase font-medium mb-4 block" data-id="element-21">
              About Me
            </span>
            <div className="mb-8" data-id="element-22">
              <div className="w-36 h-36 rounded-full overflow-hidden border-4 border-white shadow-lg" data-id="element-23">
                <img src="https://cdn.magicpatterns.com/uploads/a5beiyWk8FUiKPzhMNYdNN/574572980_840617571820679_5066793111663355885_n.jpg" alt="Tunga - Photographer" className="w-full h-full object-cover object-top" data-id="element-24" />
              </div>
            </div>
            <h2 className="font-serif text-4xl md:text-5xl text-charcoal mb-8 leading-tight" data-id="element-25">
              Hello, I'm Tunga.
            </h2>
            <div className="space-y-5 text-charcoal/80 leading-relaxed font-light" data-id="element-26">
              <p data-id="element-27">
                I'm a photographer based in the beautiful Shenandoah Valley.
                Surrounded by rolling hills, Massanutten Mountain, and golden
                sunsets, I fell in love with freezing life's most meaningful
                moments.
              </p>
              <p data-id="element-28">
                I specialize in families, couples, and newborns — and I'm
                especially comfortable with little ones, from wiggly toddlers to
                sleepy babies. Whether we're shooting at the JMU Arboretum, a
                local vineyard, or your favorite Valley spot, I'll help you
                create images that feel authentic and timeless.
              </p>
            </div>

            <div className="mt-10" data-id="element-29">
              
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}